/**
 * Opens Airtable contact form for legacy team plans
 * Used when old plan users need to contact support for:
 * - Editing team profile
 * - Managing subscription
 * - Adding/removing seats
 * - Getting more credits
 */
export const openContactUsForm = (): void => {
	window.open(
		"https://airtable.com/appqIlvnjfPjskCLX/pagDwW9FSJDfNKxqH/form",
		"_blank",
		"noopener,noreferrer"
	);
};
